import { getTodayDate } from "./DateToday";

// Prefer runtime-injected config if present (set by public/runtime-env.js), else fall back to build-time env
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const runtimeCfg: any = (typeof window !== 'undefined' && (window as any).__RUNTIME_CONFIG__) || {};
const BaseUrl = runtimeCfg.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL;
const EventUrl = runtimeCfg.REACT_APP_EVENT_URL || process.env.REACT_APP_EVENT_URL;
const OrgId = runtimeCfg.REACT_APP_ORG_ID || process.env.REACT_APP_ORG_ID;
const today = getTodayDate();

export function UrlToQuery(props: string): string {
  var urlToQuery = ''

  switch (props) {
    case 'parkingLots':
      urlToQuery = (BaseUrl + OrgId + "/parkinglots");
      break;

    case 'parkingStatus':
      urlToQuery = (BaseUrl + OrgId + "/parkinglots/status");
      break;

    case 'handicapSpot':
      urlToQuery = (BaseUrl + OrgId + "/parkingspaces?type=handicap");
      break;

    case 'elSpot':
      urlToQuery = (BaseUrl + OrgId + "/parkingspaces?type=el car");
      break;

    case 'events':
      urlToQuery = `${EventUrl}${OrgId}/next?after=${today}`;
      break;

    default:
      urlToQuery = (BaseUrl + OrgId + "/parkinglots");
      break;
  }

  return urlToQuery;
}

